var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.dateslist),function(date,index){return _c('li',{key:index,class:{ active: index == _vm.selectedIndex },on:{"click":function($event){return _vm.reloadData(date, index)}}},[_c('a',[_vm._v(_vm._s(date.dateno))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }